module.exports = __webpack_public_path__ + "img/personal-backup.f758353a.png";